module.exports = __webpack_public_path__ + "static/media/piz_img.97928fac.jpg";